import KhmelnytskenergozbutTariffmax from "@/plugins/api/factories/KhmelnytskenergozbutTariffmax";

export const state = {
  debtData: null,
  paymentResponse: null,
  paymentData: {
    ls: null,
    amount: null,
    cardNumber: null,
    cardExpiry: null,
    cardCvv: null,
  },
  cards: null,
};

export const actions = {
  async checkDebt({ commit }, accountNumber) {
    console.log(
      "CHLENIX NO COMISSION checkDebt accountNumber: ",
      JSON.stringify(accountNumber)
    );
    return await KhmelnytskenergozbutTariffmax.checkDebt(
      accountNumber,
      (response) => {
        console.log(
          "CHLENIX NO COMISSION checkDebt: ",
          JSON.stringify(response)
        );
        commit("SET_DEBT_DATA", response);
        return response;
      }
    );
  },
  async makePayment({ commit, state }, paymentDetails) {
    const paymentData = {
      ls: paymentDetails.ls || state.paymentData.ls,
      amount: paymentDetails.amount || state.paymentData.amount,
      cardNumber: paymentDetails.cardNumber || state.paymentData.cardNumber,
      cardExpiry: paymentDetails.cardExpiry || state.paymentData.cardExpiry,
      cardCvv: paymentDetails.cardCvv || state.paymentData.cardCvv,
    };

    return await KhmelnytskenergozbutTariffmax.makePayment(
      paymentData,
      (response) => {
        commit("SET_PAYMENT_RESPONSE", response);
        return response;
      }
    );
  },
  async getCards({ commit }) {
    return KhmelnytskenergozbutTariffmax.getCards((response) => {
      console.log("CHLENIX getCards: " + JSON.stringify(response));
      commit("SET_CARDS", response);
    });
  },
  async payWithSavedCard({ commit, state }, paymentDetails) {
    const paymentData = {
      ls: paymentDetails.ls || state.paymentData.ls,
      amount: paymentDetails.amount || state.paymentData.amount,
      cardId: paymentDetails.cardId || state.paymentData.cardId,
    };

    return await KhmelnytskenergozbutTariffmax.payWithSavedCard(
      paymentData,
      (response) => {
        commit("SET_PAYMENT_RESPONSE", response);
        return response;
      }
    );
  },
};

export const mutations = {
  SET_DEBT_DATA(state, data) {
    state.debtData = data;
  },
  SET_PAYMENT_RESPONSE(state, response) {
    state.paymentResponse = response;
  },
  SET_ACCOUNT_NUMBER(state, accountNumber) {
    state.paymentData.ls = accountNumber;
  },
  SET_PAYMENT_AMOUNT(state, amount) {
    state.paymentData.amount = amount;
  },
  SET_CARD_NUMBER(state, cardNumber) {
    state.paymentData.cardNumber = cardNumber;
  },
  SET_CARD_EXPIRY(state, cardExpiry) {
    state.paymentData.cardExpiry = cardExpiry;
  },
  SET_CARD_CVV(state, cardCvv) {
    state.paymentData.cardCvv = cardCvv;
  },
  UPDATE_PAYMENT_DATA(state, paymentData) {
    state.paymentData = { ...state.paymentData, ...paymentData };
  },
  SET_CARDS(state, cards) {
    state.cards = cards;
  },
};
